import React from "react";
import Apitable from "./Apitable";

const API = () => {
    return (
        <div className="api-container">
            <Apitable/>
        </div>
    );
};

export default API;
